import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "rightWrap"
};
const _hoisted_2 = {
  class: "contentwrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_domstyle = _resolveComponent("domstyle");
  const _component_uploadfile = _resolveComponent("uploadfile");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "titlebox"
  }, "内容管理", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_domstyle, {
    value: $data.dragNode.style,
    onDomstyle: $options.inputChange
  }, null, 8, ["value", "onDomstyle"]), _createVNode(_component_el_form_item, null, {
    default: _withCtx(() => [_createVNode(_component_uploadfile, {
      name: "fillimage",
      uploadList: $data.dragNode.image,
      width: 90,
      height: 90,
      onFileList: _cache[0] || (_cache[0] = $event => $options.fileListHandle($event, 'dragimage'))
    }, null, 8, ["uploadList"])]),
    _: 1
  }), _createVNode(_component_el_form_item, {
    class: "topbottom"
  }, {
    label: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("span", null, "链接地址", -1)])),
    default: _withCtx(() => [_createVNode(_component_el_input, {
      modelValue: $data.link.url,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.link.url = $event),
      placeholder: "请输入http://或https://开头的地址",
      onChange: _cache[2] || (_cache[2] = $event => $options.linkInputChange($event, 'url'))
    }, null, 8, ["modelValue"])]),
    _: 1
  }), _createVNode(_component_el_form_item, null, {
    default: _withCtx(() => [_createVNode(_component_el_checkbox, {
      modelValue: $data.link.way,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.link.way = $event),
      label: "新页面打开",
      onChange: _cache[4] || (_cache[4] = $event => $options.linkInputChange($event, 'way'))
    }, null, 8, ["modelValue"])]),
    _: 1
  })])], 512)), [[_vShow, $data.rightShow]]);
}